import '@/styles/global.css';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';
import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';
import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

const App = () => {
  const { slug } = useParams();

  return (
    <div className="tw-isolate">
      <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
        <NuqsAdapter>
          <Outlet />
          <HanaFloatingChatLazy />
        </NuqsAdapter>
        <AddBaseFunctionality />
      </SPALayout>
    </div>
  );
};

export default App;
